import React from 'react'
import CustomContainer from '../../components/CustomContainer'
import { Col, Row } from 'react-bootstrap'
import { Player } from 'video-react'
import { IMAGES } from '../../constants'

const AnimationPage = () => {
    return (
        <div className='animation'>
            <div className='overlay'>
                <CustomContainer size={8}>
                    <h1 className='title my-4' data-aos="fade-down">The Power of Animation</h1>
                    <p data-aos="fade-down">At PIXEL MOTUS, we believe that stunning visuals are at the core of impactful storytelling. Our 3D product animation and expert color grading services turn your ideas into captivating visual experiences. Whether it's detailed product demos or vivid color enhancements, our team delivers precision and creativity that elevate your brand. Discover our work and see the difference.</p>
                    <Row className='d-flex justify-content-between'>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="my-4">
                            <div className='animationItem' data-aos="zoom-in">
                                <Player
                                    playsInline
                                    muted
                                    controls
                                    poster={IMAGES?.thum2}
                                    src={IMAGES?.video}
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="my-4">
                            <div className='animationItem' data-aos="zoom-in" data-aos-delay="100">

                                <Player
                                    playsInline
                                    muted
                                    controls
                                    poster={IMAGES?.thum1}
                                    src={IMAGES?.video}
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="my-4">
                            <div className='animationItem' data-aos="zoom-in" data-aos-delay="200">

                                <Player
                                    playsInline
                                    muted
                                    controls
                                    poster={IMAGES?.thum4}
                                    src={IMAGES?.video}
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="my-4">
                            <div className='animationItem' data-aos="zoom-in" data-aos-delay="300">

                                <Player
                                    playsInline
                                    muted
                                    controls
                                    poster={IMAGES?.thum3}
                                    src={IMAGES?.video}
                                />
                            </div>
                        </Col>
                    </Row>
                </CustomContainer>
            </div>
        </div>
    )
}

export default AnimationPage